<h1>Users</h1>

<nz-input-group [nzSuffix]="suffixIconSearch" style="margin: 30px 0; max-width: 500px">
  <input
    type="text"
    nzSize="large"
    nz-input
    placeholder="input search text"
    [(ngModel)]="searchQuery"
    (keyup.enter)="onSearch()"
  />
</nz-input-group>
<ng-template #suffixIconSearch>
  <span nz-icon nzType="search"></span>
</ng-template>


<nz-table
  #usersTable
  [nzData]="users"
  [nzBordered]="true"
  [nzSize]="'middle'"
  [nzFrontPagination]="false"
  [nzLoading]="loading"
>
  <thead>
  <tr>
    <th>Name</th>
    <th>Email</th>
    <th>Tenants</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let data of usersTable.data">
    <td>{{ data.name }}</td>
    <td>{{ data.email }}</td>
    <td>
      @for (tenant of data.tenants; track $index){
        <nz-tag style="cursor: pointer" (click)="openTenant(tenant.id)">
          {{tenant.name}}
        </nz-tag>
      }
    </td>
  </tr>
  </tbody>
</nz-table>
